/* Routes.js */

import React from 'react';
import { Switch, useHistory } from 'react-router-dom';
import { toast } from 'react-toastify';
import Route from './Route';
import api from '../services/api';
import { useAuth } from '../context/auth/AuthContext.js';
import Strings from '../translations/Translations';

import Homepage from '../pages/home/Homepage';
// import SignIn from '../pages/auth/SignIn';
import SignIn3 from '../pages/auth/SignIn3/SignIn3.js';
import SignUp from '../pages/auth/SignUp';
// import ForgotPassword from '../pages/auth/ForgotPassword';
import Dashboard from '../pages/dashboard/Dashboard';
import CreateSocialLinks from '../pages/links/CreateSocialLinks';
import EditSocialLinks from '../pages/links/EditSocialLinks';
import About from '../pages/other/About';
import Account from '../pages/user/Account';
import NotFound from '../pages/errors/NotFound';
import Apps from '../pages/other/Apps';

export default function Routes() {
  const history = useHistory();
  const { logout, setShowMessageNoCredits, setShowMessageAiOperationsLimit, setOpenModalSubscribe } = useAuth();

  // Error handler
  api.interceptors.response.use(
    (response) => {
      try {
        if (response && response.result === 'error' && response.errorID === 801) {
          setShowMessageNoCredits(false);
          setShowMessageAiOperationsLimit(true);
          setOpenModalSubscribe(true);
        }
      } catch (err) {
        console.error(err);
      }
      
      return response;
    },
    (error) => {
      if (error && error.response && error.response.status === 500) {
        let message = Strings('general_error');
        if (error.response.errorText) { message = error.response.errorText;
        } else if (error.response.data.errorText) { message = error.response.errorText; }
        toast.error(message);
        logout();
        history.push('/login');
      }
      return Promise.reject(error);
    }
  );
  
  return (
    <Switch>
      <Route path="/login" exact component={SignIn3} isAuth />
      <Route path="/" exact component={SignIn3} isAuth />
      <Route path="/signup/" exact component={SignUp} isAuth />
      {/* <Route path="/forgot-password" exact component={ForgotPassword} isAuth /> */}
      <Route path="/dashboard" exact component={Dashboard} isPrivate />
      <Route path="/create" exact component={CreateSocialLinks} isPrivate />
      <Route path="/edit/:rid" exact component={EditSocialLinks} isPrivate />
      <Route path="/account" exact component={Account} isPrivate />
      <Route path="/about" exact component={About} isPrivate />
      <Route path="/apps" exact component={Apps} isPrivate />

      <Route path="/homepage" exact component={Homepage} />
      <Route component={NotFound} notFound />
    </Switch>
  );
}
